<template>
  <div
    v-if="moduleData && moduleData.id"
    class="module-options"
  >
    <div class="module-options__inner">
      <div class="module-options__item module-options__item--text">
        <legend class="module-options__legend">
          {{ $t('Text') }}
        </legend>
        <NebulaInput
          class="module-options__text-input"
          :text="decodedText"
          type="text"
          @input="changeText"
        />
      </div>

      <div class="module-options__item module-options__item--theme">
        <fieldset
          class="module-options__theme-fieldset"
          role="radiogroup"
        >
          <legend class="module-options__legend">
            {{ $t('Theme') }}
          </legend>
          <div class="module-options__theme-variations">
            <ButtonThemeSelect
              :canvas-name="canvasName"
              :module-data="moduleData"
            />
          </div>
        </fieldset>
      </div>
    </div>
    <ShapeBorderOptions
      :canvas-name="canvasName"
      :module-data="moduleData"
    />
  </div>
</template>

<script>
import { NebulaInput } from '@discoveryedu/nebula-components';
import { cloneDeep } from 'lodash-es';
import { mapActions } from 'pinia';
import ShapeBorderOptions from '@/components/modules/ShapeBorderOptions.vue';
import ButtonThemeSelect from '@/components/ButtonThemeSelect.vue';
import { UPDATE_MODULE } from '@/lib/constants/store';
import { decodeHTML } from '@/lib/utils';
import {
  useEditorStore,
} from '@/stores';

export default {
  name: 'ButtonModuleOptions',
  components: {
    ButtonThemeSelect,
    NebulaInput,
    ShapeBorderOptions,
  },
  props: {
    canvasName: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    moduleData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    decodedText() {
      // Button text is escaped on the BE and must be unescaped (e.g. &amp; => &)
      if (!this.moduleData.options) return '';
      return decodeHTML(this.moduleData.options.text);
    },
  },
  methods: {
    ...mapActions(useEditorStore, [
      UPDATE_MODULE,
    ]),
    changeText(newText) {
      const data = cloneDeep(this.moduleData);
      data.options.text = newText;
      this[UPDATE_MODULE]({ canvasName: this.canvasName, payload: data });
    },
  },
};
</script>
